import { fromJS, Record } from 'immutable';

export const ContentState = Record({
  data: null,
  loading: false,
  saving: false,
  loaded: false,
  error: null
});

const identity = (x) => x;
const defaultPath = () => [];
const initialState = new ContentState();

export function handleContentRoutines(routineConfigs) {
  const reducers = {};
  for (const config of routineConfigs) {
    const { routine, path = defaultPath, type = 'query', payloadSelector = identity } = config;

    const statusProp = type === 'query' ? 'loading' : 'saving';

    reducers[routine.PENDING] = (state, action) => {
      return state.updateIn(path(action), initialState, (state) =>
        state.merge({
          [statusProp]: true
        })
      );
    };

    reducers[routine.FULFILLED] = (state, action) => {
      const update = {
        error: null,
        [statusProp]: false
      };

      if (action.payload !== undefined) {
        update.data = fromJS(payloadSelector(action.payload));
      }

      if (type === 'query') {
        update.loaded = true;
      }

      return state.updateIn(path(action), initialState, (state) => state.merge(update));
    };

    reducers[routine.REJECTED] = (state, action) => {
      return state.updateIn(path(action), initialState, (state) =>
        state.merge({
          error: action.payload,
          [statusProp]: false
        })
      );
    };
  }

  return reducers;
}
